import React from 'react';

import { useDataAttributes } from '@lumapps/data-attributes';
import { Reactions } from '@lumapps/reactions-core/components/Reactions';

import { useBlockVideoContext } from '../BlockVideoContext';
import { CLASSNAME as BLOCK_VIDEO_CLASSNAME } from '../constants';

export const CLASSNAME = `${BLOCK_VIDEO_CLASSNAME}-reactions` as const;

/**
 * Displays the reaction icon of a video
 */
export const ReactButton = () => {
    const { get } = useDataAttributes(CLASSNAME);

    const { video, theme } = useBlockVideoContext();

    if (!video) {
        return null;
    }

    return (
        <Reactions.React
            resourceRef={{ resourceType: 'play-video', resourceId: video?.id }}
            reactionCounts={video?.reactionCounts}
            currentUserReactions={video?.currentUserReactions}
            theme={theme}
            {...get({ element: 'button', action: 'like' })}
        />
    );
};
